import { Component, OnInit, Input, AfterContentChecked } from '@angular/core';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';

@Component({
  selector: 'app-dashboard-broadcast-activity-avg-card',
  templateUrl: './dashboard-broadcast-activity-avg-card.component.html',
  styleUrls: ['./dashboard-broadcast-activity-avg-card.component.scss']
})
export class DashboardBroadcastActivityAvgCardComponent implements OnInit, AfterContentChecked {

    @Input() data;
    count: any;
    showCounter: boolean;

    constructor(private spinnerService: SpinnerService) {
      this.showCounter = false;
    }

    ngOnInit() {
    }

    ngAfterContentChecked() {
      this.spinnerService.show('activity-avg-counts-spinner');
      if ((null !== this.data) && (undefined !== this.data) && ('-' !== this.data)) {
        this.spinnerService.hide('activity-avg-counts-spinner');
        this.showCounter = true;
        this.count = this.data.length;
      } else if ('-' === this.data) {
        this.count = '-';
        this.showCounter = true;
        this.spinnerService.hide('activity-avg-counts-spinner');
      }
    }

  }

